module.exports = __webpack_public_path__ + "img/sceneIcon1-6.477faf8c.png";